import { useRef, useState, useEffect } from 'react'
import throttle from 'lodash/throttle'
import { CoverLetter, Resume } from 'packages/types'
import {
  ColorChangeHandler,
  TemplateCategories,
  TemplateChangeHandler,
} from 'builder/modules/resumeEditor'
import { TemplatesPreviewList } from 'builder/components/TemplatesList/TemplatesPreviewList'
import { ColorSelection } from '../ColorSelection/ColorSelection'
import { Container, TemplateSelectionContainer } from './styles'

interface TemplateSelectionProps {
  currentDocument: Resume | CoverLetter
  updateTemplate: TemplateChangeHandler
  handleColorSelect: ColorChangeHandler
}

export const TemplateSelection = (props: TemplateSelectionProps) => {
  const { currentDocument, updateTemplate, handleColorSelect } = props
  const templateListRef = useRef<HTMLDivElement | null>(null)
  const [isScrolled, setIsScrolled] = useState(false)

  const handleScroll = throttle(() => {
    if (templateListRef.current) {
      setIsScrolled(templateListRef.current.scrollTop > 0)
    }
  }, 200)

  useEffect(() => {
    const element = templateListRef.current
    if (element) {
      element.addEventListener('scroll', handleScroll)
      return () => element.removeEventListener('scroll', handleScroll)
    }
  }, [handleScroll])

  return (
    <Container isScrolled={isScrolled}>
      <ColorSelection
        {...{
          isScrolled,
          currentDocument,
          handleColorSelect,
        }}
      />
      <TemplateSelectionContainer id="resume-templates-container" ref={templateListRef}>
        <TemplatesPreviewList
          selectedCategory={TemplateCategories.all}
          selectedTemplates={[]}
          currentDocument={currentDocument}
          updateTemplate={updateTemplate}
        />
      </TemplateSelectionContainer>
    </Container>
  )
}
